import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/icons/search.png'
import _imports_1 from '../../assets/icons/filter.png'
import _imports_2 from '../../assets/icons/gridView.png'
import _imports_3 from '../../assets/icons/listView.png'


const _hoisted_1 = { class: "main-container content-start mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title col-start-1 col-end-13 mb-0" }, "Takip Listesi", -1)
const _hoisted_3 = { class: "actions-row col-start-1 col-end-13 flex items-center justify-between gap-4" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Ara",
  class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6 opacity-50"
}, null, -1)
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "filter-main",
  src: _imports_2,
  alt: "Filtrele"
}
const _hoisted_13 = {
  key: 1,
  class: "filter-main",
  src: _imports_3,
  alt: "Filtrele"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "flex gap-2 overflow-x-scroll max-w-[20vw] overflow-x-bars-hidden" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "col-start-1 col-end-13 grid grid-cols-4 gap-8"
}

import { ref, computed } from "vue"
import type { fetchedUser } from "@/types"
import type { AcTrackedPotential } from "@/types/crm"
import type { Ref } from 'vue'
import type { ColorMetaField } from "@/types/metas"
import { useGetFilteredDocs, useGetDocs } from "@/mixins/modularFirebaseOperations"
import { reactivateTrackedPotential } from "@/composables/crmBasedFunctions"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import AcDataTable from "@/components/reusable/acDataTable.vue"
import StarDisplay from "@/components/reusable/starDisplay.vue"
import ModernStatusChip from "@/components/reusable/modernStatusChip.vue"
import FilterPopup from "@/components/reusable/filterPopup.vue"
import CrmPotentialCard from "@/components/crm-components/potentialCard.vue"
import SkeletonTable from "@/components/reusable/skeletonTable.vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'archivedTracked',
  setup(__props) {

const { docs, isLoadingDocs } = useGetFilteredDocs("crm/tracked/list", { status: "INACTIVE" })
const potentials = docs as Ref<AcTrackedPotential[]>

// Get job categories for filtering
const { docs: categoryDocs } =  useGetDocs("crm/jobCategories/list")
const jobCategories = categoryDocs as Ref<ColorMetaField[]>

// Search and filter state
const searchQuery = ref('')
const selectedCategoryFilter = ref<ColorMetaField | null>(null)
const isShowingCategoryFilter = ref(false)
const isShowingAssignedToMe = ref(false)
const store = useStore()
const router = useRouter()
const userProfile = computed(() => store.getters['user/userProfile'])
const prefView = computed(() => userProfile.value?.preferences?.crmView || 'list')

// Sorting state
const sortColumn = ref('')
const sortDirection = ref<'asc' | 'desc'>('asc')

const changeUserView = () => {

    if(prefView.value === 'list'){
        store.dispatch('user/changeCrmPreference', { key: 'crmView', value: 'card' })
    } else {
        store.dispatch('user/changeCrmPreference', { key: 'crmView', value: 'list' })
    }
}

// Handle category filter selection
const handleCategorySelected = (category: ColorMetaField | undefined) => {
    selectedCategoryFilter.value = category || null
}

const handleCategoryFilterClosed = () => {
    isShowingCategoryFilter.value = false
}

const user = userProfile.value


// Filtered potentials based on search and category
const filteredPotentials = computed(() => {
    let filtered = potentials.value

    // Filter by search query
    if (searchQuery.value.trim()) {
        const query = searchQuery.value.toLowerCase().trim()
        filtered = filtered.filter(potential => 
            potential.title.toLowerCase().includes(query) ||
            potential.description?.toLowerCase().includes(query) ||
            potential.potentialCategories.some((cat: ColorMetaField) => cat.name?.toLowerCase().includes(query))
        )
    }

    // Filter by selected category
    if (selectedCategoryFilter.value) {
        filtered = filtered.filter(potential => 
            potential.potentialCategories.some((cat: ColorMetaField) => cat.id === selectedCategoryFilter.value?.id)
        )
    }

    // Filter by assigned to me
    if (isShowingAssignedToMe.value && user?.userId) {
        filtered = filtered.filter(potential => 
            potential.assignedTo?.some((assignedUser: fetchedUser) => assignedUser.id === user.userId)
        )
    }

    return filtered
})

// Sorted and filtered potentials
const sortedAndFilteredPotentials = computed(() => {
    let result = [...filteredPotentials.value]

    // Apply sorting if a sort column is selected
    if (sortColumn.value) {
        const column = dataCols.value.find((col: any) => col.key === sortColumn.value)
        
        result.sort((a, b) => {
            // Use custom sort function if available
            if (column?.sortFunction) {
                const tableDataA = {
                    id: a.id,
                    title: a.title,
                    categories: a.potentialCategories,
                    potentialRating: a.potentialRating,
                    priority: {
                        displayName: priorityData[a.priority as keyof typeof priorityData]?.displayName || a.priority,
                        sortValue: priorityData[a.priority as keyof typeof priorityData]?.sortValue ?? 999,
                        rawValue: a.priority
                    },
                    trackedAt: {
                        displayValue: (a.trackedAt instanceof Date ? a.trackedAt : (a.trackedAt as any).toDate()).toLocaleDateString("tr-TR"),
                        sortValue: (a.trackedAt instanceof Date ? a.trackedAt : (a.trackedAt as any).toDate()).getTime()
                    },
                    actions: a
                }
                
                const tableDataB = {
                    id: b.id,
                    title: b.title,
                    categories: b.potentialCategories,
                    potentialRating: b.potentialRating,
                    priority: {
                        displayName: priorityData[b.priority as keyof typeof priorityData]?.displayName || b.priority,
                        sortValue: priorityData[b.priority as keyof typeof priorityData]?.sortValue ?? 999,
                        rawValue: b.priority
                    },
                    trackedAt: {
                        displayValue: (b.trackedAt instanceof Date ? b.trackedAt : (b.trackedAt as any).toDate()).toLocaleDateString("tr-TR"),
                        sortValue: (b.trackedAt instanceof Date ? b.trackedAt : (b.trackedAt as any).toDate()).getTime()
                    },
                    actions: b
                }
                
                return column.sortFunction(tableDataA, tableDataB)
            }
            
            // Default sorting for other columns
            const aValue = a[sortColumn.value as keyof typeof a]
            const bValue = b[sortColumn.value as keyof typeof b]
            
            // Handle undefined/null values
            if (aValue == null && bValue == null) return 0
            if (aValue == null) return -1
            if (bValue == null) return 1
            
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return aValue.localeCompare(bValue)
            }
            
            if (aValue < bValue) return -1
            if (aValue > bValue) return 1
            return 0
        })
        
        // Apply sort direction
        if (sortDirection.value === 'desc') {
            result.reverse()
        }
    }

    return result
})

const priorityData = {
    "LOW": {
        "displayName": "Düşük",
        "sortValue": 0
    },
    "STANDARD": {
        "displayName": "Standart",
        "sortValue": 1
    },
    "HIGH": {
        "displayName": "Yüksek",
        "sortValue": 2
    }
}

const tableData = computed(() => {
    return sortedAndFilteredPotentials.value.map(doc => {
        const trackedAtDate = doc.trackedAt instanceof Date ? doc.trackedAt : (doc.trackedAt as any).toDate()
        const priorityInfo = priorityData[doc.priority as keyof typeof priorityData]
        return {
            id: doc.id, // Include the original id for navigation
            title: doc.title,
            categories: doc.potentialCategories,
            potentialRating: doc.potentialRating,
            priority: {
                displayName: priorityInfo?.displayName || doc.priority,
                sortValue: priorityInfo?.sortValue ?? 999, // Use high number for unknown priorities
                rawValue: doc.priority
            },
            trackedAt: {
                displayValue: trackedAtDate.toLocaleDateString("tr-TR"),
                sortValue: trackedAtDate.getTime() // Use timestamp for sorting
            },
            actions: doc, // Include the full tracked potential object for actions
        }
    })
})

const dataCols = computed(() => [
    {
        title: sortColumn.value === "title" 
            ? `Başlık ${sortDirection.value === 'asc' ? '▲' : '▼'}` 
            : "Başlık",
        key: "title",
        width: "20%",
        isSortable: true
    },
    {
        title: "Kategoriler",
        key: "categories",
        width: "20%",
        isSortable: false,
    },
    {
        title: sortColumn.value === "trackedAt" 
            ? `Takip Tarihi ${sortDirection.value === 'asc' ? '▲' : '▼'}` 
            : "Takip Tarihi",
        key: "trackedAt",
        width: "20%",
        isSortable: true,
        sortFunction: (a: any, b: any) => {
            const aValue = a.trackedAt?.sortValue ?? 0
            const bValue = b.trackedAt?.sortValue ?? 0
            return aValue - bValue
        }
    },
    {
        title: sortColumn.value === "potentialRating" 
            ? `Fırsat Düzeyi ${sortDirection.value === 'asc' ? '▲' : '▼'}` 
            : "Fırsat Düzeyi",
        key: "potentialRating",
        width: "20%",
        isSortable: true,
        sortFunction: (a: any, b: any) => {
            const aValue = a.potentialRating ?? 0
            const bValue = b.potentialRating ?? 0
            return aValue - bValue
        }
    },
    {
        title: sortColumn.value === "priority" 
            ? `Takip Önceliği ${sortDirection.value === 'asc' ? '▲' : '▼'}` 
            : "Takip Önceliği",
        key: "priority",
        width: "10%",
        isSortable: true,
        sortFunction: (a: any, b: any) => {
            const aValue = a.priority?.sortValue ?? 999
            const bValue = b.priority?.sortValue ?? 999
            return aValue - bValue
        }
    },
    {
        title: "İşlemler",
        key: "actions",
        width: "10%",
        isSortable: false,
    },

])

const navigateToPotential = (item: any) => {
    router.push(`/crm/tracked-detail/${item.id}`)
}

const handleColumnSort = (columnKey: string) => {
    if (sortColumn.value === columnKey) {
        // If clicking the same column, toggle direction
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc'
    } else {
        // If clicking a new column, set it as sort column with ascending direction
        sortColumn.value = columnKey
        sortDirection.value = 'asc'
    }
}

const handleTrackedPotentialReactivated = async (trackedPotential: AcTrackedPotential) => {
    const confirmation = confirm("Bu takip edilen potansiyel aktif hale getirilecek ve normal takip listesinde görünür olacaktır. Devam etmek istiyor musunuz?")
    console.log(confirmation)
    if(confirmation) {
        await reactivateTrackedPotential(trackedPotential)
        // Redirect to the reactivated tracked potential's detail page
        router.push(`/crm/tracked-detail/${trackedPotential.id}`)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Fırsatlarda ara...",
            class: _normalizeClass(["px-12 py-3 opacity-50 text-2xl border border-gray-300 rounded-lg focus:outline-none min-w-[250px]", { '!opacity-100': searchQuery.value !== '' }])
          }, null, 2), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isShowingCategoryFilter.value = true), ["stop"])),
            class: _normalizeClass(["ac-add-button", { 'stateful-background': selectedCategoryFilter.value }])
          }, [
            _createElementVNode("img", {
              class: _normalizeClass({'filter-white': !selectedCategoryFilter.value}),
              src: _imports_1,
              alt: "Filtrele"
            }, null, 2),
            (selectedCategoryFilter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(selectedCategoryFilter.value.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Kategori"))
          ], 2),
          (isShowingCategoryFilter.value)
            ? (_openBlock(), _createBlock(FilterPopup, {
                key: 0,
                onFilterClosed: handleCategoryFilterClosed,
                onItemSelected: handleCategorySelected,
                class: "absolute w-max",
                itemList: _unref(jobCategories),
                "displayed-attribute": "name"
              }, null, 8, ["itemList"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowingAssignedToMe.value = !isShowingAssignedToMe.value)),
          class: _normalizeClass(["ac-add-button", { 'stateful-background': isShowingAssignedToMe.value }])
        }, [
          _createElementVNode("img", {
            class: _normalizeClass({'filter-white': !isShowingAssignedToMe.value}),
            src: _imports_1,
            alt: "Bana Atananları Listele"
          }, null, 2),
          (isShowingAssignedToMe.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Bana Atananlar"))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, "Bana Atananları Listele"))
        ], 2),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeUserView())),
          class: "ac-add-button"
        }, [
          (prefView.value === 'list')
            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
            : _createCommentVNode("", true),
          (prefView.value === 'card')
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true),
          (prefView.value === 'card')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Liste Görünümü"))
            : _createCommentVNode("", true),
          (prefView.value === 'list')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Kart Görünümü"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(isLoadingDocs))
      ? (_openBlock(), _createBlock(SkeletonTable, {
          key: 0,
          class: "col-start-1 col-end-13 w-full",
          width: "100",
          rows: "20"
        }))
      : (!_unref(isLoadingDocs) && prefView.value === 'list')
        ? (_openBlock(), _createBlock(AcDataTable, {
            key: 1,
            onRowClicked: _cache[4] || (_cache[4] = ($event: any) => (navigateToPotential($event))),
            onColumnSorted: handleColumnSort,
            class: "w-full col-start-1 col-end-13",
            data: tableData.value,
            columns: dataCols.value
          }, {
            "cell-potentialRating": _withCtx(({ value }) => [
              _createVNode(StarDisplay, { "picked-quantity": value }, null, 8, ["picked-quantity"])
            ]),
            "cell-categories": _withCtx(({ value }) => [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (category) => {
                  return (_openBlock(), _createBlock(ModernStatusChip, {
                    key: category.id,
                    text: category.name,
                    bgColors: { [category.id]: category.color },
                    value: category.id,
                    class: "text-sm"
                  }, null, 8, ["text", "bgColors", "value"]))
                }), 128))
              ])
            ]),
            "cell-priority": _withCtx(({ value }) => [
              _createElementVNode("span", _hoisted_17, _toDisplayString(value.displayName), 1)
            ]),
            "cell-trackedAt": _withCtx(({ value }) => [
              _createElementVNode("span", null, _toDisplayString(value.displayValue), 1)
            ]),
            "cell-actions": _withCtx(({ value }) => [
              _createElementVNode("button", {
                class: "ac-table-button",
                onClick: _withModifiers(($event: any) => (handleTrackedPotentialReactivated(value)), ["stop"])
              }, " Aktif Hale Getir ", 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["data", "columns"]))
        : (!_unref(isLoadingDocs) && prefView.value === 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedAndFilteredPotentials.value, (potential) => {
                return (_openBlock(), _createBlock(CrmPotentialCard, {
                  key: potential.id,
                  potential: potential,
                  onClick: ($event: any) => (navigateToPotential(potential))
                }, null, 8, ["potential", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})